import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Title, Text, Form, InputPassword, Button } from 'ui';
import { changePassword } from 'api';
import "./index.css";


export default function ChangePassword() {
  
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  
  
  async function save() {
    setError("");
    
    if(!password) {
      setError("Please enter a password.");
      return;
    }
    if(password !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    try {
      await changePassword(password);
    }
    catch(error) {
      setError(error.message);
      return;
    }
    history.push('view');
  }
  
  function cancel() {
    history.push('view');
  }
  
  
  return (
    <Form onSubmit={save} className="changepassword">
    
      <Title>Change Password</Title>
    
      <InputPassword 
        value={password}
        onChange={setPassword}
        label="Password"
      />
      
      <InputPassword
        value={confirm}
        onChange={setConfirm}
        label="Confirm Password"
      />
      
      <Text color="red">{error}</Text>
      
      <div className="changepassword-actions">
        <Button label="Change Password" submit/>
        <Button tertiary label="Cancel" onClick={cancel}/>
      </div>
      
    </Form>
  );
}